(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  window.bvCallback = (BV) => {
    BV.configure('global', {
      events: {
        bvRender: function (data) {
          // JavaScript code that executes when the Bazaarvoice application renders.
          const event = new CustomEvent('bv-render-ready');
          event.detail = data;

          window.dispatchEvent(event);
        },
      },
    });
  };

  } catch(e) { console.error(e); }
})();
})();
